var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "justify-content": "space-between",
        "align-items": "center"
      }
    },
    [
      _c(
        "cargo-user-select",
        _vm._g(
          _vm._b(
            {
              staticStyle: { flex: "1" },
              attrs: { disabled: _vm.disabled, "default-value": _vm.job.sales },
              on: { change: _vm.onSalesChange }
            },
            "cargo-user-select",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "el-checkbox",
        {
          staticStyle: { "margin-left": "5px" },
          attrs: { disabled: true },
          on: {
            change: function($event) {
              return _vm.onChange("provisioned")
            }
          },
          model: {
            value: _vm.job.provisioned,
            callback: function($$v) {
              _vm.$set(_vm.job, "provisioned", $$v)
            },
            expression: "job.provisioned"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.Accrued")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }